export default "__VITE_ASSET__BJLxIk5k__"